<template>
<div :class="{'container-fluid': !isSettingsComponent}">
	<apps-toolbar v-if="!isSettingsComponent" title="Integrations" icon="fa-puzzle-piece"></apps-toolbar>

	<h2>Integrations</h2>

	<widget title="Quickbooks Online">

		<div class="d-flex justify-content-between align-items-center flex-wrap">
			<img :src="$store.apiRoot+'resources/qbo-logo.jpg'" style="max-width: 250px">

			<button v-if="!qboIsActive" class="btn btn-primary" v-on:click="activateQBO">
				<i class="fa fa-toggle-on"></i>
				Activate
			</button>

			<template v-else>
				<div>
					<span class="mr-2">
						<strong class="text-success">Active: </strong>
						<span> Connected to <strong>{{qboCompanyName}}</strong></span>
					</span>

					<button class="btn btn-light" v-on:click="deactivateQBO">
						<i class="fa fa-toggle-off"></i>
						De-Activate
					</button>

				</div>

			</template>
			
		</div>
		<template v-if="qboIsActive">
			<form v-on:submit.prevent="saveQBOSettings">

				<div class="row">
					<div class="col-lg-6">

						<h4>Tax Connections</h4>
						<p>Please tell us how to connect the {{$store.appName}} tax settings to the Quickboox Online Tax Codes:</p> 

						<field v-for="(taxValue,label) in appTaxes" 
							:key="label"
							:label="label" 
							col-class="col-md-6"
							:params="{type:'select',options:qboSalesTaxOptions}" v-model="taxConnections[label]">
						</field>

						<h5>Zero Rate</h5>
						<p>Please tell Tradetraks which QBO Tax Code is the zero-rated one:</p>

						<field 
							label="Zero-Rated Code" 
							col-class="col-md-6"
							:params="{type:'select',options:qboSalesTaxOptions}" 
							v-model="zeroRatedTaxCodeId">
						</field>

						<field 
							label="Default Exchange Rate" 
							col-class="col-md-6"
							:params="{type:'number', step:'0.0001'}"
							v-model="qboExchangeRate">
						</field>
					</div>

					<!--
					<h4>Revenue/Expense Code Type Mapping</h4>
					<p>Please tell us which QBO Account Types are Revenue Codes, and which are Expense Codes</p> 
					<field 
						label="Revenue Code Account Types" 
						col-class="col-md-6"
						:params="{type:'select-multi',options:qboAccountTypeOptions}"
						v-model="revenueCodeAccountTypes">
						<p>This will tell us what Account Types in Quickbooks may be selected as Revenue Codes in Tradetraks</p>
					</field>

					<field 
						label="Expense Code Account Types" 
						col-class="col-md-6"
						:params="{type:'select-multi',options:qboAccountTypeOptions}"
						v-model="expenseCodeAccountTypes">
						<p>This will tell us what Account Types in Quickbooks may be selected as Expense Codes in Tradetraks</p>
					</field>
					-->

					<div class="col-lg-6">

						<h4>Account Mapping</h4>

						<template v-if="ccAccounts.length > 0">
	
							<p>If you would like to restrict access of your credit card accounts to certain users, you can set it here. Leaving an account blank means anyone can submit an expense under that account.</p>

							<field v-for="(ccAccount,index) in ccAccounts"
								:label="ccAccount.Name+': '+ccAccount.Description"
								col-class="col-md-5"
								:params="{type:'select-multi',options:userOptions()}"
								v-model="ccAccountsUsers[index]">
							</field>

							<hr>
						</template>

						<field v-if="cashAccountOptions.length > 0"
							label="Cash Account" 
							col-class="col-md-5"
							:params="{type:'select',options:cashAccountOptions}"
							v-model="cashAccount">
							<p>This will tell us what Account to book a Business Cash expense under in Quickbooks</p>
						</field>

						<alert v-else-if="qboConnectionFetched" :unclosable="true" classes="alert-danger" :visible="true" icon="fa-exclamation">It doesn't look like you have any Bank Accounts set up in Quickbooks, please set up a "Bank" account type in Quickbooks for cash purchases, and then set it here.</alert>

						<hr>

						<field v-if="accountPayableOptions.length > 0"
							label="Accounts Payable Account" 
							col-class="col-md-5"
							:params="{type:'select',options:accountPayableOptions}"
							v-model="accountPayable">
							<p>This will tell us what Account to book a Bill under in Quickbooks</p>
						</field>

						<alert v-else-if="qboConnectionFetched" :unclosable="true" classes="alert-danger" :visible="true" icon="fa-exclamation">It doesn't look like you have any Account Payable accounts set up in Quickbooks, please set up an "Accounts Payable" account type in Quickbooks for bills, and then set it here.</alert>

						<spinner v-else :inline="true"></spinner>

						<h4>Billing Holdbacks</h4>
						<p>If your project billing uses holdbacks, please select the QBO Product that is your holdback</p>

						<field 
							label="Holdback Product" 
							col-class="col-md-6"
							:params="{type:'select',options:qboProductsOptions}" 
							v-model="qboHoldbackItemId"
							:loading="qboSearchLoading"
							v-on:searchChange="holdbackSearchChange">
						</field>

						<hr>

						<field 
							label="Push Timelogs to QBO" 
							col-class="col-md-6"
							:params="{type:'boolean'}" v-model="timelogPushActive">
						</field>
					</div>
				</div>

				<!--<button type="button" class="btn btn-sm btn-light" v-on:click="backCalcTaxes">Back Calculate Expense Taxes</button>-->

				<button type="submit" class="btn btn-success float-right">
					<i class="fa fa-save"></i>	
					Save
				</button>
			</form>
		</template>
	</widget>

	<widget title="Mail Server">

		<p>Sending mail from your own company emails can improve delivery rates and provide a better, more trusted experience for your clients.</p> 

		<button v-if="'CompanySetting' in $store.company && $store.company.CompanySetting.mail_client_active == 0" class="btn btn-primary" v-on:click="activateMailClient">
			<i class="fa fa-toggle-on"></i>
			Activate
		</button>

		<div class="d-flex flex-row justify-content-between align-items-center mb-2" v-else>
			<strong class="text-success">Active</strong>

			<button type="button" class="btn btn-light" v-on:click="deactivateMailClient">
				<i class="fa fa-toggle-off"></i>
				De-Activate
			</button>

		</div>

		<form v-if="'CompanySetting' in $store.company && $store.company.CompanySetting.mail_client_active == 1" v-on:submit.prevent="saveMailServerSettings">

			<field label="Email Address" 
				col-class="col-md-6"
				v-model="mailSettings.email">
			</field>

			<field label="Password" 
				col-class="col-md-6"
				:params="{type:'password'}"
				v-model="mailSettings.password">
			</field>

			<!--<field label="Incoming Server" 
				col-class="col-md-6"
				v-model="mailSettings.incomingServer">
			</field>

			<field label="Incoming Server Port" 
				col-class="col-md-6"
				v-model="mailSettings.incomingPort">
			</field>-->

			<field label="Outgoing Server" 
				col-class="col-md-6"
				v-model="mailSettings.outgoingServer">
			</field>

			<field label="SMTP Port" 
				col-class="col-md-6"
				v-model="mailSettings.outgoingPort">
			</field>

			<div class="d-flex justify-content-between">

				<button type="button" class="btn btn-dark" v-on:click="sendTestEmail">
					<i class="fa fa-paper-plane"></i>
					Send Test Email to {{$store.userDetails.email}}
				</button>

				<button type="submit" class="btn btn-success float-right">
					<i class="fa fa-save"></i>	
					Save
				</button>
			</div>
		</form>
	</widget>

</div>
</template>

<script>
import AppsToolbar from "./AppsToolbar"

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import AddonAppCard from "@/components/AddonAppCard"
import PaymentAcceptanceSettings from "@/components/super_components/PaymentAcceptanceSettings"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"
import Widget from "@/components/Widget"
import SearchBar from "@/components/SearchBar"
import Alert from "@/components/Alert"
import Spinner from "@/components/Spinner"

import ExpenseMixins from "@/mixins/ExpenseMixins.js"

export default {

	components: {
		AppsToolbar,
		ModalDialog,
		Field,
		AddonAppCard,
		PaymentAcceptanceSettings,
		CollapsiblePanel,
		PanelMenu,
		Widget,
		SearchBar,
		Alert,
		Spinner
	},
	mixins: [ExpenseMixins],
	data() {
		return {
			appTaxes: [],
			qboAccounts: [],
			qboItems: [],
			taxConnections: {},
			zeroRatedTaxCodeId: null,
			qboHoldbackItemId: null,
			qboConnection: {},
			qboConnectionFetched: false,
			qboCompanyName: "",
			qboExchangeRate: 1,
			revenueCodeAccountTypes: [],
			expenseCodeAccountTypes: [],
			ccAccountsUsers: [],
			cashAccount: null,
			accountPayable: null,
			timelogPushActive: 0,
			mailSettings: {
				email: "",
				password: "",
				/*incomingServer: "",
				incomingPort: 993,*/
				outgoingServer: "",
				outgoingPort: 465
			},
			qboSearchLoading: false
		}
	},
	props: ["isSettingsComponent"],
	watch: {
		'$store.company'() {
			this.fetchData()
		}
	},
	computed: {
		ccAccounts() {
			return this.qboAccounts.filter(account => {
				return account.AccountType == 'Credit Card'
			})
		},
		accountPayableOptions() {
			return this.qboAccounts.filter(account => {
				return account.AccountType == 'Accounts Payable'
			}).map(account => {
				return {text: account.Name, value: account.Id}
			})
		},
		cashAccountOptions() {
			//.filter(account => account.AccountType == 'Bank' || account.AccountType == 'Other Current Asset')
			return this.qboAccounts.map(account => {
				return {text: account.Name, value: account.Id}
			})
		},
		qboAccountTypeOptions() {
			let vm = this

			let accountTypes = []
			this.qboAccounts.forEach(account => {
				if (accountTypes.indexOf(account.AccountType) == -1) 
					accountTypes.push(account.AccountType)
				
			})

			return accountTypes.map(account => {
				return {text: account, value: account}
			})
		},
		qboProductsOptions() {
			return this.qboItems.map(item => {
				return {text: item.Name,value: item.Id}
			})
		}
	},
	methods: {
		activateQBO() {
			window.location.href = this.$store.apiRoot+"api/QuickbooksConnection/auth?token="+this.$store.sessionToken
			/*let vm = this

			this.postData("CompanySetting/save",{qbo_active: 1},true).then(response => {
				if (response.success) {
					
				}
			})*/
		},
		deactivateQBO() {
			let vm = this

			let promises = [
				this.postData("CompanySetting/save",{qbo_active: 0},true),
				this.postData("QuickbooksConnection/disable")
			]

			Promise.all(promises).then(responses => {
				vm.alertSaved("Quickbooks Online has been deactivated")
				vm.$store.company.CompanySetting.qbo_active = 0
			})
		},
		saveQBOSettings() {
			let vm = this

			let connections = JSON.stringify(this.taxConnections)

			let account_type_mapping_json = JSON.stringify({
				revenueCodes: this.revenueCodeAccountTypes,
				expenseCodes: this.expenseCodeAccountTypes
			})

			let credit_card_owners = []
			this.ccAccountsUsers.forEach((userIds,index) => {
				credit_card_owners.push({qbo_account_id: vm.ccAccounts[index].Id, userIds})
			})

			let payload = {
				tax_codes_json: connections,
				account_type_mapping_json,
				credit_card_owners_json: JSON.stringify(credit_card_owners),
				cash_account_qbo_id: vm.cashAccount,
				account_payable_qbo_id: vm.accountPayable,
				zero_rated_tax_code_qbo_id: vm.zeroRatedTaxCodeId,
				holdback_item_qbo_id: vm.qboHoldbackItemId,
				timelog_push_active: vm.timelogPushActive,
				exchange_rate: vm.qboExchangeRate
			}

			this.postData("QuickbooksConnection/save",payload,true).then(response => {
				if (response.success)
					vm.alertSaved("QBO Settings saved")
			})
		},
		backCalcTaxes() {
			this.postData("QuickbooksConnection/back-calculate-expenses-tax").then(response => {
				if (response.success)
					this.alertSuccess("Finished: " + response.data)
			})
		},
		activateMailClient() {
			let vm = this

			this.postData("CompanySetting/save",{mail_client_active: 1},true).then(response => {
				if (response.success) {
					vm.alertSaved("External Mail Server has been activated. Please fill in your server settings")
					vm.$store.company.CompanySetting.mail_client_active = 1
				}
			})
		},
		deactivateMailClient() {
			let vm = this

			this.postData("CompanySetting/save",{mail_client_active: 0},true).then(response => {
				if (response.success) {
					vm.alertSaved("External Mail Server has been deactivated")
					vm.$store.company.CompanySetting.mail_client_active = 0
				}
			})
		},
		saveMailServerSettings() {
			let vm = this

			let payload = {
				mail_client_json: JSON.stringify(this.mailSettings)
			}

			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Mail server settings saved")
				}
			})
		},
		sendTestEmail() {
			let vm = this

			this.postData("CompanySetting/send-test-email",{},true).then(response => {
				if (response.success)
					vm.alertSuccess("Test email sent to "+this.$store.userDetails.email)
			})
		},
		holdbackSearchChange(searchTerms) {
			if (searchTerms) {
				this.debounce("searchQboHoldbacks",searchTerms,1000)
				this.qboSearchLoading = true
			}
		},
		searchQboHoldbacks(searchTerms) {
			let vm = this

			let payload = {
				resource: "Item",
				where: "Name LIKE '%" + searchTerms + "%'"
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get-resource",payload).then(response => {
					if (response.success) 
						vm.qboItems = response.data

					vm.qboSearchLoading = false
				
					resolve(response)
				})

			})
		},
		fetchQBOCompany() {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get-resource",{resource: "CompanyInfo"},true).then(response => {
					if (response.success && response.data.length > 0)
						vm.qboCompanyName = response.data[0].CompanyName

					resolve(response)
				})

			})
		},
		fetchQboResourceList(resource, storageLocation) {
			let vm = this;
			const pageSize = 1000;

			return new Promise(async (resolve, reject) => {
				try {
					let start = 1;
					let allData = [];

					while (true && start < 5000) { //max out at 5 pages as a sanity check
						const response = await vm.getJSON(
							"QuickbooksConnection/get-resource",
							{ resource, startposition: start },
							true
						);

						if (!response.success)
							return resolve(response); // maintain your existing behavior

						const data = response.data || [];
						allData.push(...data);

						if (data.length < pageSize) break;
						start += pageSize;
					}

					vm[storageLocation] = allData;

					resolve({
						success: true,
						data: allData
					});

				} catch (err) {
					reject(err);
				}
			});
		},
		fetchQBOConnection() {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get",{},true).then(response => {

					if (response.success && response.data.length > 0) {

						try {
							let connectionObj = JSON.parse(response.data[0].tax_codes_json)

							vm.taxConnections = connectionObj
						}
						catch (ex) {}

						try {
							let accountTypesObj = JSON.parse(response.data[0].account_type_mapping_json)
							
							if ("revenueCodes" in accountTypesObj)
								vm.revenueCodeAccountTypes = accountTypesObj.revenueCodes
						
							if ("expenseCodes" in accountTypesObj)
								vm.expenseCodeAccountTypes = accountTypesObj.expenseCodes
						}
						catch (ex) {}

						try {
							let ccAccountsUsers = JSON.parse(response.data[0].credit_card_owners_json)
							
							ccAccountsUsers.forEach((account,index) => {
								let accountIndex = vm.ccAccounts.findIndex(ccAccount => ccAccount.Id == account.qbo_account_id)

								vm.ccAccountsUsers[accountIndex] = account.userIds
							})
						}
						catch (ex) {}

						vm.cashAccount = response.data[0].cash_account_qbo_id
						vm.accountPayable = response.data[0].account_payable_qbo_id
						vm.zeroRatedTaxCodeId = response.data[0].zero_rated_tax_code_qbo_id
						vm.qboHoldbackItemId = response.data[0].holdback_item_qbo_id
						vm.timelogPushActive = response.data[0].timelog_push_active
						vm.qboExchangeRate = response.data[0].exchange_rate

						vm.qboConnectionFetched = true

					}
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			if ("CompanySetting" in this.$store.company) {

				if (this.qboIsActive) {

					try {
						let taxes = JSON.parse(this.$store.company.CompanySetting.taxes_json)

						this.appTaxes = {}
						Object.keys(taxes).forEach(key => {
							if (typeof taxes[key] == 'object')
								this.appTaxes[key] = taxes[key].taxRate
							else
								this.appTaxes[key] = taxes[key]
						})
					}
					catch (e) {}

					let promises = [
						this.fetchQboSalesTaxes(),
						this.fetchQboResourceList("Account","qboAccounts"),
						this.fetchQboResourceList("Item","qboItems"),
						this.fetchUsers(),
						this.fetchQBOCompany()
					]

					Promise.all(promises).then(responses => {
						vm.fetchQBOConnection()
					})
				}
				try {
					vm.mailSettings = JSON.parse(vm.$store.company.CompanySetting.mail_client_json)
				}
				catch (e) {}		
			}
		}
	},
	created() {
		this.fetchData()
	}
}
</script>

<style type="text/css">
	.app-details-table th,
	.app-details-table td {
		padding: 5px;
		padding-bottom: 2px;
		padding-top: 2px;
	}

	.app-details-table th {
		text-align: right;
		padding-right: 10px;
	}
</style>